import React, { useEffect, useState } from "react";

// img

// Jds
import { Button, Container, Notifications, Text } from "@jds/core";

// Mui
import { Box } from "@mui/material";
import AnalyticsCard from "../components/UI/Cards/AnalyticsCard";
import GridContainer from "../components/Layout/GridContainer";
import useApiHttp from "../hooks/use-http";
import { useNavigate, useParams } from "react-router-dom";
import PageLoader from "../components/UI/Loader/PageLoader";

// Local

export default function AnalyticsPage() {
  // analytics_counts/b50cacd5-b15e-4d76-9409-80a146756681
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { sendRequest: getAnalyticsCounts, isLoading: analyticsCountsLoading } =
    useApiHttp();
  const [eventAnalyticsList, setEventAnalyticsList] = useState([]);
  const [mediaAnalyticsList, setMediaAnalyticsList] = useState([]);
  const [analyticsList, setAnalyticsList] = useState([]);
  useEffect(() => {
    getAnalyticsCounts(
      {
        url: `event-attendee/analytics_counts/${eventId}`,
      },
      null,
      (data) => {
        setEventAnalyticsList([
          {
            ic: "IcLinkedAccounts",
            heading: "Persons Registered",
            data: data?.data?.registeredGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "REGISTERED" },
              });
            },
          },
          {
            ic: "IcGroup",
            // icProps: {
            //   color: "sparkle",
            //   kind: "default",
            //   size: "medium",
            // },
            heading: "Persons Invited",
            data: data?.data?.invitedGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "NULL" },
              });
            },
          },
          {
            ic: "IcSuccess",
            heading: "Persons Approved",
            data: data?.data?.approveGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "APPROVED" },
              });
            },
          },
          {
            ic: "IcAccessibility",
            heading: "Persons with Full Access",
            data: data?.data?.fullAccessCount,
          },
          {
            ic: "IcSmileyNeutral",
            heading: "Persons with Face Access",
            data: data?.data?.faceAccessCount,
          },
          // {
          //   ic: "IcDownload",
          //   heading: "Downloads Requested",
          //   data: data?.data?.downloadRequestsCount,
          // },
          {
            ic: "IcDownload",
            heading: "Persons with Download Access",
            data: data?.data?.approvedDownloadCount,
          },
          {
            ic: "IcError",
            heading: "Persons Denied",
            data: data?.data?.denyGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "DENIED" },
              });
            },
          },
          {
            ic: "IcBlocked",
            heading: "Persons Blocked",
            data: data?.data?.blockedGusetCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "blocked" },
              });
            },
          },
        ]);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "analytics_counts",
          title: data.message,
        });
      }
    );

    getAnalyticsCounts(
      {
        url: `analytics/photos?eventId=${eventId}`,
        base: "MEDIA",
      },
      null,
      (data) => {
        setMediaAnalyticsList([
          {
            ic: "IcPhoto",
            heading: "Event Photos",
            data: data?.data?.eventPhotosCount,
          },
          {
            ic: "IcPhoto",
            heading: "Guest Photos",
            data: data?.data?.guestPhotosCount,
          },
          {
            ic: "IcPhoto",
            heading: "Photos Approved for Guests",
            data: data?.data?.guestApprovedPhotosCount,
          },
          // {
          //   ic: "IcCompare",
          //   heading: "Persons viewed per photo",
          //   data: data?.data?.registeredGuestCount,
          // },
          // {
          //   ic: "IcDownload",
          //   heading: "Photos Downloaded",
          //   data: data?.data?.downloadRequestsCount,
          // },
          {
            ic: "IcSmileySatisfied",
            heading: "Faces Displayed",
            data: data?.data?.facesCount,
          },
        ]);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "analytics_counts",
          title: data.message,
        });
      }
    );
  }, []);

  useEffect(() => {
    if (eventAnalyticsList.length && mediaAnalyticsList.length)
      setAnalyticsList([...eventAnalyticsList, ...mediaAnalyticsList]);
  }, [eventAnalyticsList, mediaAnalyticsList]);
  return (
    <>
      <Container direction="column" gap={8}>
        <Text text="Analytics" appearance="heading-xs" />
        <Text text="Metrics" color="primary_grey_80" appearance="body-m-bold" />
      </Container>
      <Container fullWidth style={{ marginTop: "16px" }}>
        <GridContainer minWidth={"240px"}>
          {analyticsList.map((item, i) => (
            <AnalyticsCard
              key={i}
              icon={item?.ic}
              heading={item?.heading}
              data={item?.data}
              icProps={item?.icProps}
              onClick={item?.onClick}
            />
          ))}
        </GridContainer>
        {analyticsCountsLoading && <PageLoader open={analyticsCountsLoading} />}
      </Container>
    </>
  );
}
